import { Component, OnInit } from '@angular/core';
import { CommonModule, NgIf } from '@angular/common';
import { DataFetcherService } from '../../../services/data-fetcher/data-fetcher.service';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';

@Component({
  selector: 'app-dataflow-info',
  standalone: true,
  imports: [RouterLink, CommonModule],
  templateUrl: './dataflow-info.component.html',
  styleUrl: './dataflow-info.component.css'
})
export class DataflowInfoComponent {
  newUrl: string = '';
  dataflow: any;  // Array to store the list of dataflows
  dataflowId: string | undefined; //Get the dataflowId for API request

  constructor(private dataFetcher: DataFetcherService, private route: ActivatedRoute, private router: Router) {}

  ngOnInit() {
    // Access  the dataflow ID from the route parameters
    this.route.params.subscribe(params => {
      this.dataflowId = params['dataflowId'];  // Workspace ID
      this.newUrl = this.router.url.toString().replace('/dataflow/'+this.dataflowId, '');
    });
    // Fetch the dataflow data when the component initializes
    this.dataFetcher.GetDataflowByIdData(this.dataflowId).subscribe(
      (data: any) => {
        // Extract the 'dataflows' array from the data object
        this.dataflow = data.dataflows[0] || null;  // Fallback to an empty array if 'dataflows' is undefined
      },
      (error) => {
        console.error('Error fetching dataflow data', error);
      }
    );
    console.log(this.dataflow);
  }
}

